<template>
  <div class="custom-select mr-4" @click="toggleDropdown">
    <div class="selected-option">
      <img
        v-if="selectedCountry"
        :src="selectedCountry.flag"
        :alt="selectedCountry.name"
        class="flag-icon"
      />
      <p v-if="selectedCountry">{{ selectedCountry.prefix }}</p>
    </div>
    <ul v-if="isDropdownOpen" class="dropdown-options">
      <li
        v-for="country in countriesArray"
        :key="country.code"
        @click.stop="selectCountry(country)"
      >
        <img :src="country.flag" :alt="country.name" class="flag-icon" />
        <span>{{ country.prefix }}</span>
      </li>
    </ul>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import countryData from "@/assets/data/countryData.json";

interface Country {
  code: string;
  name: string;
  prefix: string;
  flag: string;
}

export default defineComponent({
  name: "PhonePrefix",
  props: {
    modelValue: {
      type: [String, Number],
      default: ""
    }
  },
  emits: ["update:modelValue", "selectedPrefix"],
  data() {
    return {
      selectedCode: "", // código de país para mostrar bandera
      isDropdownOpen: false,
      countries: {} as Record<string, Country>,
    };
  },
  computed: {
    selectedCountry(): Country | undefined {
      return this.countries[this.selectedCode];
    },
    countriesArray(): Country[] {
      return Object.values(this.countries);
    }
  },
  watch: {
    modelValue: {
      immediate: true,
      handler(newVal) {
        const entry = Object.entries(this.countries).find(
          ([code, data]) => data.prefix.replace("+", "") === String(newVal)
        );
        if (entry) {
          this.selectedCode = entry[0];
        }
      }
    }
  },
  methods: {
    toggleDropdown() {
      this.isDropdownOpen = !this.isDropdownOpen;
    },
    selectCountry(country: Country) {
      this.selectedCode = country.code;
      this.isDropdownOpen = false;
      const prefixNumber = Number(country.prefix.replace("+", ""));
      this.$emit("update:modelValue", prefixNumber);
      this.$emit("selectedPrefix", prefixNumber);
    },
    getDefaultSPAIN() {
      if (!this.modelValue) {
        const spain = this.countries["ES"];
        if (spain) this.selectCountry(spain);
      }
    }
  },
  async mounted() {
    try {
      this.countries = countryData as Record<string, Country>;
      const sortedArray = Object.entries(this.countries).sort(
        (a, b) => a[1].name.localeCompare(b[1].name)
      );
      this.countries = Object.fromEntries(sortedArray);

      this.getDefaultSPAIN();
    } catch (error) {
      console.error("Error loading country data:", error);
    }
  }
});
</script>

<style scoped>
.custom-select {
  position: relative;
  cursor: pointer;
  align-items: center;
}

.selected-option {
  display: flex;
  align-items: center;
  -webkit-backdrop-filter: blur(16px);
  backdrop-filter: blur(16px);
  height: 44px;
  padding: 10px;
  font-size: 14px;
  background: rgba(255, 255, 255, 0.02);
  border: 1px solid;
  border-radius: 24px;
  box-shadow: inset 0px 0px 12px rgba(255, 255, 255, 0.15);
  border-bottom-color: #264b67;
  border-left-color: #264b67;
  border-right-color: #076ae3;
  border-top-color: #264b67;
}

.flag-icon {
  width: 24px;
  height: 18px;
  margin-right: 5px;
}
.dropdown-options {
  max-height: 200px;
  width: fit-content;
  overflow-y: auto;
  -webkit-backdrop-filter: blur(16px);
  backdrop-filter: blur(16px);
  padding-left: 6px;
  font-size: 14px;
  background: rgba(255, 255, 255, 0.02);
  border: 1px solid;
  border-radius: 24px;
  box-shadow: inset 0px 0px 12px rgba(255, 255, 255, 0.15);
  border-bottom-color: #264b67;
  border-left-color: #264b67;
  border-right-color: #076ae3;
  border-top-color: #264b67;
}

.dropdown-options li {
  padding: 6px;
  display: flex;
  align-items: center;
  cursor: pointer;
}

.dropdown-options li:hover {
  background-color: #6f91da;
}

.dropdown-options img {
  width: 24px;
  height: 18px;
  margin-right: 6px;
}
</style>
